import { NgTemplateOutlet } from '@angular/common';
import { Component, input, signal, TemplateRef } from '@angular/core';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { GalleriaModule } from '@openng/optimus-ui/galleria';
import { ImagePreviewItem } from '../../models/gallery.models';

@Component({
  selector: 'lib-image-preview',
  imports: [DialogModule, GalleriaModule, NgTemplateOutlet],
  templateUrl: './image-preview.html',
  styleUrl: './image-preview.scss',
  standalone: true
})
export class ImagePreview {
  images = input.required<ImagePreviewItem[]>();
  title = input<string>('');
  subheadingTemplate = input<TemplateRef<unknown> | null>(null);
  showThumbnails = input(false);

  readonly visible = signal(false);
  readonly activeIndex = signal(0);

  open(index = 0): void {
    if (!this.images().length) {
      return;
    }
    this.activeIndex.set(index);
    this.visible.set(true);
  }

  onVisibleChange(visible: boolean): void {
    this.visible.set(visible);
  }

  onActiveIndexChange(index: number): void {
    this.activeIndex.set(index);
  }
}
